import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	approversTitle: {
		id: 'software-releases-approvers.approvers-title',
		defaultMessage: 'Approvers',
		description: 'The title of the approvers card',
	},
	noApproversMessage: {
		id: 'software-releases-approvers.no-approvers-message',
		defaultMessage: 'No approvers have been added',
		description: 'The message on the approvers card when there are no approvers.',
	},
	showMore: {
		id: 'software-releases-approvers.show-more',
		defaultMessage: 'Show all approvers',
		description: 'Title of a button that shows the rest of the approvers list.',
	},
	showLess: {
		id: 'software-releases-approvers.show-less',
		defaultMessage: 'Show less',
		description: 'Title of a button that hides the rest of the approvers list.',
	},
	addApproversAriaLabel: {
		id: 'software-releases-approvers.add-approvers-aria-label',
		defaultMessage: 'Add approvers',
		description: 'An aria label for the add approvers button',
	},
});
